import {
  type PartnerAccountResponse,
  type PartnerStatus,
} from '@/api/routes/partners/partners.api';
import { type PartnerGate } from '@/domain/account-status/types';
import { translatedMap } from '@/i18n';
import { ScreenRoutes } from '@/types/router';
import { SUPPORT_PHONE } from '@/utils/data';

/** Edit and resubmit the account (P06) or review what was sent (P05). */
export const ONBOARDING_EDIT_URL = `${ScreenRoutes.ONBOARDING}?mode=edit`;

/** Bodyprint support on WhatsApp, the same number bodyprint-web uses. */
export const SUPPORT_WHATSAPP_URL = `https://wa.me/${SUPPORT_PHONE}`;

/** Statuses in which the owner can still edit the account (contract: `PUT /partners/me`). */
const EDITABLE_STATUSES: PartnerStatus[] = ['pending_review', 'rejected'];

export const getPartnerGate = (account?: PartnerAccountResponse | null): PartnerGate =>
  account?.partner ? account.partner.status : 'onboarding';

export const canEditPartnerAccount = (account?: PartnerAccountResponse | null) =>
  Boolean(
    account?.partner &&
    account.role === 'owner' &&
    EDITABLE_STATUSES.includes(account.partner.status),
  );

/** Short status label for the account chip in the top bar. */
export const partnerStatusLabel = translatedMap('domain.account-status.utils', {
  pending_review: 'status.pending_review',
  approved: 'status.approved',
  rejected: 'status.rejected',
  suspended: 'status.suspended',
} as const);
